import { useTranslation } from "react-i18next";
import { Btn } from "@/ui/btn/Btn";
import { useCalculator } from "../../hooks/useCalculator";
import { useCalculatorPaymentSubmit } from "../../hooks/useCalculatorPaymentSubmit";
import { useCalculatorUpdate } from "../../hooks/useCalculatorUpdate";

export const CalculatorPaymentBtn: React.FC<{
  className?: string;
}> = ({ className }) => {
  const { data } = useCalculatorUpdate();

  const isAuthorized = data.isAuthorized;

  if (isAuthorized === true) {
    return <CalculatorPaymentMethodBtn className={className} />;
  }

  return <CalculatorPaymentAuthBtn className={className} />;
};

const CalculatorPaymentMethodBtn: React.FC<{
  className?: string;
}> = ({ className }) => {
  const { t } = useTranslation();
  const setPaymentMethodDialogOpen = useCalculator(
    (state) => state.setPaymentMethodDialogOpen,
  );

  return (
    <Btn
      className={className}
      text={t("Select Payment Method")}
      color="primary"
      size="lg"
      onClick={() => setPaymentMethodDialogOpen(true)}
    />
  );
};

const CalculatorPaymentAuthBtn: React.FC<{
  className?: string;
}> = ({ className }) => {
  const { t } = useTranslation();
  const { trigger } = useCalculatorPaymentSubmit();

  return (
    <Btn
      className={className}
      text={t("Sign Up now")}
      color="primary"
      size="lg"
      onClick={() => trigger()}
    />
  );
};
